import styled from 'styled-components'

export const FeedConteiner = styled.div`
background-image: url('images/backgrounds/background9.jpg');
background-size: cover;
 background-position: center;
`

export const ContactSection = styled.div`
    padding: 50px 0;
    text-align: center
`

export const Input = styled.input`
    box-sizing: border-box;
    outline: 0;
    padding: 5px;
    margin-bottom: 10px
`


export const FeedImg = styled.img`
height: 85px;
width: 85px;
`
export const FeedDate =styled.h4`
font-family: 'Indie Flower', cursive;
font-weight:bold;
color:white;

`
export const FeedCon =styled.div`
    font-weight: normal;
   margin-bottom:5px;
   font-family: 'Asap', sans-serif;
   color:white;
   background-color: rgba(0, 0, 0, 0.5);
   width:30%;
`
export const  FeedbackTitle=styled.h1` 
    color:white;
    text-align:center;
    font-family: 'Shadows Into Light', cursive;
    font-size:5em
    font-weight:bold;
    text-shadow: 2px 2px 4px #000000;
    `
    export const NoFeedbackTitle=styled.div` 
    color:white;
    text-align:center;
    font-family: 'Shadows Into Light', cursive;
    font-size:3em
    font-weight:bold;
    text-shadow: 2px 2px 4px #000000;
    padding-top:10%;
    padding-bottom:15%;
    `






    export const CreateFeedIConteiner = styled.div`
    text-align: center
    font-family: 'Indie Flower', cursive;
    background-repeat: no-repeat;
    background-image: url('images/backgrounds/background8.jpg');
   background-size: cover;
   padding-bottom:5%;
`

    export const CreateFeedTitle=styled.h1` 
    text-align:center;
    font-family: 'Shadows Into Light', cursive;
    // font-size:3em
    font-weight:bold;
    padding-top:2%;
    `

    export const CreateFeedImg = styled.img`
height: 130px;
width: 100%px;
`

export const TextArea = styled.textarea`
    outline: 0;
    background: #ccc
    width:50%;
`

export const Remainder = styled.div`
color:red;
font-size: 20px;
font-weight:bold;
`